import { useQuery } from '@apollo/client/react';
import { Trans, useTranslation } from 'next-i18next/pages';
import dynamic from 'next/dynamic';
import { useReducer } from 'react';

import { CandidateDocument } from '@pflegia/data-access/candidate.generated';
import { CONTACT_JOB_DETECTIVE_OPTION_PRIORITIES, CandidatePriority } from '@pflegia/types/api/candidate/candidate-priority';
import { useAuth } from '@pflegia/ui/contexts/auth.context';

import EmptyListComponent from '../empty-list-component/EmptyList.component';

const GetInTouchModal = dynamic(() => import('@domains/dashboard/components/get-in-touch/GetInTouchModal.component'));

const JobListEmptyWithModal: React.FC = () => {
  const [getInTouchModalVisible, toggleGetInTouchModal] = useReducer(state => !state, false);
  const authenticated = useAuth();
  const { data: candidateData } = useQuery(CandidateDocument, { skip: !authenticated });

  const candidate = candidateData?.candidate;
  const candidatePriority = candidate?.priority;
  const hasJobDetective = candidatePriority && CONTACT_JOB_DETECTIVE_OPTION_PRIORITIES.includes(candidatePriority as CandidatePriority);

  const { t } = useTranslation('jobBoard', { keyPrefix: 'emptyList' });

  return (
    <>
      {getInTouchModalVisible && hasJobDetective && (
        <GetInTouchModal hasPhoneNumber={Boolean(candidate?.phoneNumber)} onDismiss={toggleGetInTouchModal} />
      )}
      <EmptyListComponent
        variant={hasJobDetective ? 'noResultsContactJobDetective' : 'noResults'}
        hasJobDetective={Boolean(hasJobDetective)}>
        <p className='whitespace-pre-wrap text-center text-lg font-semibold lg:text-left'>
          <Trans
            components={{
              button: <button className='text-main-blue' onClick={toggleGetInTouchModal} />,
              span: <span className='text-main-blue' />,
            }}
            i18nKey={hasJobDetective ? 'noResultsContactJobDetective' : 'noResults'}
            t={t}
          />
        </p>
      </EmptyListComponent>
    </>
  );
};

export default JobListEmptyWithModal;
